import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';
import 'leaflet/dist/leaflet.css';
import './i18n.js';
import "./custom.scss";

const root = ReactDOM.createRoot(document.getElementById('root'));

const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN;
const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const auth0Audience = process.env.REACT_APP_AUTH0_AUDIENCE;

// Mode local sans Auth0 ni back (npm run start:sandbox), cf. docs/onboarding. Le test sur
// NODE_ENV est évalué à la compilation : le sandbox est retiré du build de production.
if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_SANDBOX === 'reconditioning') {
  import('./sandbox/ReconditioningSandbox').then(({ default: Sandbox }) => {
    root.render(<Sandbox />);
  });
} else {
  root.render(
    <React.StrictMode>
      <Auth0Provider
        domain={auth0Domain}
        clientId={auth0ClientId}
        authorizationParams={{
          redirect_uri: `${window.location.origin}/auth`,
          audience: auth0Audience,
          scope: "openid profile email read:roles create:users assign:roles read:organizations offline_access",
        }}
        cacheLocation="localstorage"
        useRefreshTokens={true}
        useRefreshTokensFallback={true}
      >
        <App />
      </Auth0Provider>
    </React.StrictMode>
  );
}
